<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body" v-loading="is_loading">
			<div class="center">
				<div class="home_main">
					<div class="search_wrap">
						<div class="search_box">
							<i class="iconfont el-icon-search"></i>
							<input class="in" placeholder="点击输入框粘贴截图" @paste="handlePaste"/>
							<i class="iconfont icon-xiangji"><input class="image-uploader" type="file" accept="image/*" capture="camera" @change="onFileChange"></i>
						</div>
					</div>
					<img class="search-image" :src="imageUrl"  v-if="imageUrl" alt="">
					<div class="product_section" >
						<div class="screen_wrap" v-if="imageUrl">
							<div class="order_sort">
                <div @click="onOrder('_score')" :class="{active:order==='_score'}">
                  综合排序
                </div>
                <div @click="onOrder('discount_price')" :class="{active:order==='discount_price'}">
                  价格排序
                </div>
                <div @click="onOrder('public_time')" :class="{active:order==='public_time'}">
                  新品排序
                </div>
              </div>
							<p class="title" >相似款商品共<span>{{page_data.total}}</span>件</p>
							<!-- <p class="in_btn" @click="allPuhuo()">一键加入</p> -->
						</div>
						<productList v-if="imageUrl" :listData="list" :loading="product_loading"></productList>
						<el-empty v-if="!imageUrl" description="请点击输入框上传图片搜索吧~"></el-empty>

<!--						<div class="turn_page">-->
<!--							<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getProduct" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[20,50,100,200,500,1000]" />-->
<!--						</div>-->

					</div>
				</div>
			</div>
		</div>
		<myFoot :showBeian="true"></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import "swiper/swiper-bundle.min.css";
import { mapActions,mapState,mapMutations } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import productList from '../../components/productList/productlist';
import common from '../../assets/js/utils/common';
import headDefault from '../../assets/images/head.png';
import Pagination from '../../components/pagination/pagination';

export default {
	name: "index",
	data(){
		return{
			uploadAction:"",
			headDefault,
			input1:'',
			input2:'',
			login_type:1,
			reg_step:1,
			list:[],
			userId:"",
			loadingCode:false,
			userinfo:"",
			avatar:"",
			is_loading: false,
			product_loading:false,
			currGroupId: 0,
			searchParams: {},
			page_data: {
				limit: 20,
				page: 1,
				total:0,
			},
			imageUrl:'',
      order:'_score'

		}
	},
	components:{
		myHead,myFoot,productList,Pagination
	},
	mounted(){
		// this.$nextTick(function () {
		// 	window.addEventListener('scroll', this.onScroll)
		// })
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
			avatars:(state)=>state.login.avatar,
			ucmenu:(state)=>state.login.ucmenu,
		}),
	},
	created() {
		this.userinfo = this.users?this.users:""
		this.avatar = this.avatars || headDefault
		var query = this.$route.query
		if(query){
			this.searchParams = query
		}
		this.init()
	},
	destroyed() {
		 // window.removeEventListener('scroll', this.onScroll)
	},
	methods:{
		...mapActions({
			doAddAllProduct:"cart/doAddAllProduct",
			doSearchProductByImage:"index/doSearchProductByImage",
			getBusinessOrderCount:"index/getBusinessOrderCount",
			getCodeData:"login/getCodeData",
			getQrcodeData:"login/getQrcodeData",
			checkWxBind:"login/checkWxBind",
			DoAccountLogin:"login/DoAccountLogin",
			DoCodeLogin:"login/DoCodeLogin",
			DoRegister:"login/DoRegister",
			getUcenterMenu:"login/getUcenterMenu",
		}),
		...mapMutations({
			OUT_LOGIN:"login/OUT_LOGIN"
		}),
		handlePaste(event) {
			const items = (event.clipboardData || window.clipboardData).items;
			for (let i = 0; i < items.length; i++) {
				if (items[i].kind === 'file') {
					const file = items[i].getAsFile();
					if (file.type.startsWith('image/')) {
						// 创建一个FileReader对象
						const reader = new FileReader();
						reader.onload = (e) => {
							// 读取完成后，将图片的Data URL赋值给pastedImageUrl
							this.imageUrl = e.target.result;
							this.refresh()
						};
						// 以Data URL的形式读取文件
						reader.readAsDataURL(file);
						// 停止循环，因为我们只处理第一个图片文件
						break;
					}
				}
			}
		},
		onFileChange(e){
			const file = e.target.files[0];
			if (!file) return;

			// 创建一个FileReader实例
			const reader = new FileReader();

			// 读取文件为DataURL（Base64编码）
			reader.readAsDataURL(file);

			// 处理文件读取完成后的事件
			reader.onload = (e) => {
				this.imageUrl = e.target.result; // e.target.result 就是图片的Base64编码
				this.refresh()
			};

			// 错误处理
			reader.onerror = error => console.log('Error: ', error);
		},
		allPuhuo(){
			this.doAddAllProduct({data:{},success:(res) => {
				if(res.code == 200){
					this.$message({message: res.msg,type: 'success',});
				}else{
					this.$message({message: res.msg,type: 'error',});
				}
			}})

		},
		codeLoginClick(){
			this.login_type = 1
			setTimeout(()=>{this.loadingCode = true},100)
			this.getLoginCode('',true,'1')
		},
		accountLoginClick(){
			this.login_type = 2
			clearTimeout(this.checkBindTimer)
		},
		init(){
			this.getProduct()
		},
		getUCmenu(){
			this.getUcenterMenu({data:{},success:(res)=>{
				if(res.status==200){
					console.log('getUCmenu',res)
					// this.employeeData.data = res.data
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
    onOrder(row){
      this.order = row
      this.getProduct()
    },
		//获取商品列表
		getProduct(){
			if(this.product_loading) return
			this.product_loading = true
			this.list = []
			document.documentElement.scrollTop = 400
			let searchParams = this.searchParams
			let param = {limit:this.page_data.limit,page:this.page_data.page,image:this.imageUrl,order:this.order}
			Object.assign(param, searchParams)
			// console.log(param)
			this.doSearchProductByImage({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get goods list',res)
					// if(this.page_data.page == 1){
					// 	this.list = res.data.data
					// }else{
					// 	this.list = this.list.concat(res.data.data)
					// }
					this.list = res.data.data
					this.page_data.total = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.product_loading = false
				// this.page_data.page ++
			}})
		},
		//滚动加载
		onScroll(){
			// 滚动条到最顶端的距离
			let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
			let clientHeight = document.documentElement.clientHeight
			let scrollHeight = document.documentElement.scrollHeight
			if(scrolled + clientHeight + 400 >= scrollHeight){
				this.loadMore()
			}
		},
		//刷新列表
		refresh(){
			this.page_data.page = 1
			this.getProduct()
			this.getOrderCount()
		},
		//清空筛选
		reset(){
			this.searchParams = {}
			this.refresh()
		},
		//加载商品
		loadMore(){
			if (this.page_data.total <= this.list.length) {
				return false
			} else{
				this.getProduct()
			}
		},

		searchTap(name,val){
			if(!this.searchParams[name] || this.searchParams[name] != val){
				this.searchParams[name] = val
			}else{
				this.searchParams[name] = 0
			}
			this.refresh()
		},
		typeCommand(val){
			this.searchParams.name_type = val
			this.refresh()
		},
		priceCommand(val){
			this.searchParams.price_sort = val
			this.refresh()
		},
		timeCommand(val){
			this.searchParams.time_sort = val
			this.refresh()
		},
		supplierCommand(val){
			this.searchParams.supplier_user_id = val
			this.refresh()
		},


	}
}
</script>

<style scoped>
.image-uploader{position: absolute;left: 0;top: 0;width: 100%;height: 100%;opacity: 0;}
.search-image{width: 140px;height: 140px;object-fit: contain;margin: 20px auto;display: block;}
.home_main{width: 100%;height: auto;margin-top: 30px;margin-bottom: 40px;}
.search_wrap{margin: 0 auto;display: flex;justify-content: center;font-size: 16px;}
.search_wrap .search_box{width: 900px;height: 50px;box-sizing: border-box;background-color: #ffffff;border-radius: 4px 0vw 0vw 4px;border: solid 2px #fa5757;display: flex;align-items: center;position: relative;}
.search_wrap .search_box .type{width: 84px;color: #333333;cursor: pointer;text-align: center;line-height: 26px;border-right: 1px solid #ddd;}
.search_wrap .search_box .in{flex: 1;width: 0;margin: 0 15px;color: #333333;font-size: 16px;}
.search_wrap .search_box .el-icon-search{margin-left: 14px;font-size: 20px;color: #999;cursor: pointer;}
.search_wrap .search_box .icon-xiangji{margin-right: 14px;font-size: 24px;color: #999;cursor: pointer;position: relative;}
.search_wrap .search_btn{width: 132px;height: 50px;background-image: linear-gradient(180deg, #fa5757 0%, #fb6d6d 100%), linear-gradient(#ffffff, #ffffff);background-blend-mode: normal, normal;border-radius: 0vw 4px 4px 0vw;display: flex;justify-content: center;align-items: center;color: #ffffff;font-weight: bold;cursor: pointer;}

.label_line .tab_lv2 .lv2:hover ,.label_line .tabs_wrap .tab_lv3:hover{color: #e4393c;}


.product_section{width: 100%;height: auto;box-sizing: border-box;background: #fff;margin-top: 20px;padding: 0 20px 20px;}
.product_section .screen_wrap{width: 100%;height: 47px;border-bottom: 1px solid #eeeeee;display: flex;align-items: center;justify-content: space-between}
.screen_wrap .title{
  font-weight: bold;
/*  margin-right: 60px;*/
}
.screen_wrap .title span{color: #fa5757;}
.screen_wrap .tab{font-size: 14px;margin-right: 40px;display: flex;align-items: center;cursor: pointer;}
.screen_wrap .tab:hover{color: var(--red);text-decoration: underline;}
.screen_wrap .tab.active{color: #fa5757;}
.screen_wrap .in_box{width: 54px;height: 24px;border: 1px solid #ccc;box-sizing: border-box;padding: 0 6px;display: flex;align-items: center;font-size: 14px;color: #999;}
.screen_wrap .in_box .in{margin-left: 6px;}
.screen_wrap .in_line{width: 20px;display: flex;justify-content: center;align-items: center;color: #999999;}
.screen_wrap .in_btn{margin-left: 12px;width: auto;padding:0 10px;height: 26px;background: #ddd;display: flex;justify-content: center;align-items: center;cursor: pointer;font-size: 12px;color: #666666;}

</style>
<style>

.order_sort{
  display: flex;
  align-items: center;
  div{
    margin-right: 20px;
    cursor: pointer;
    font-size: 14px;
    color: #999999;
  }
  .active{
    color: #fa5757;
  }
}
</style>
